class Logger {
    debugLog() {
        try {
            if (window && window.console && window.console.log) window.console.log.apply(window.console, arguments);
        } catch (e) {
        }
    }

    errorLog() {
        try {
            if (window && window.console && window.console.error) window.console.error.apply(window.console, arguments);
        } catch (e) {
        }
    }

    warnLog() {
        try {
            if (window && window.console && window.console.warn) window.console.warn.apply(window.console, arguments);
        } catch (e) {
        }
    }
}

export let logger = new Logger();